import { render, staticRenderFns } from "./history-form.vue?vue&type=template&id=20560852&scoped=true"
import script from "./history-form.vue?vue&type=script&lang=js"
export * from "./history-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20560852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20560852')) {
      api.createRecord('20560852', component.options)
    } else {
      api.reload('20560852', component.options)
    }
    module.hot.accept("./history-form.vue?vue&type=template&id=20560852&scoped=true", function () {
      api.rerender('20560852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/history-form.vue"
export default component.exports